import { createAction } from '@reduxjs/toolkit';
const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
const SET_ACTIVE_COUNTRY_OPTION = 'SET_ACTIVE_COUNTRY_OPTION';
const SET_ACTIVE_LANGUAGE_OPTION = 'SET_ACTIVE_LANGUAGE_OPTION';
export const setCountryList = createAction(SET_COUNTRY_LIST);
export const setActiveCountryItem = createAction(SET_ACTIVE_COUNTRY_OPTION);
export const setActiveLanguageItem = createAction(SET_ACTIVE_LANGUAGE_OPTION);
